import PropTypes from "prop-types";
import React__default from "react";
import { useTheme } from "react-jss";
import { COLORS } from "../../EatClubTheme.js";
import { Dropdown } from "../Dropdown/Dropdown.js";
const DateRangeDropdown = ({
  value = "",
  items = [],
  onSelect = () => {
  },
  onFocus = () => {
  },
  onBlur = () => {
  },
  style = {},
  disabled = false,
  valueOverride = "",
  ...other
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const theme = useTheme();
  const styles = {
    ...style,
    outerContainer: {
      display: "flex",
      gap: "10px",
      alignItems: "center",
      height: "40px",
      minWidth: "150px",
      ...style == null ? void 0 : style.outerContainer
    },
    disabled: {
      color: ((_a = theme == null ? void 0 : theme.colors) == null ? void 0 : _a.nimbus) || COLORS.NIMBUS,
      ...style == null ? void 0 : style.disabled
    },
    label: {
      color: ((_b = theme == null ? void 0 : theme.colors) == null ? void 0 : _b.smoke) || COLORS.NIMBUS,
      marginBottom: "0",
      width: "100px",
      ...style == null ? void 0 : style.label
    },
    dropdown: {
      border: `1px solid ${((_c = theme == null ? void 0 : theme.colors) == null ? void 0 : _c.dropdownOutline) || COLORS.LINEN_DARK}`,
      borderBottom: `1px solid ${((_d = theme == null ? void 0 : theme.colors) == null ? void 0 : _d.dropdownOutline) || COLORS.LINEN_DARK}`,
      backgroundColor: ((_e = theme == null ? void 0 : theme.colors) == null ? void 0 : _e.pageBackground) || COLORS.LINEN,
      width: "100%",
      color: ((_f = theme == null ? void 0 : theme.colors) == null ? void 0 : _f.charcoal) || COLORS.CHARCOAL,
      borderRadius: "8px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      fontSize: "16px",
      paddingRight: "30px",
      minWidth: "150px",
      lineHeight: "18px",
      transition: "background-color 0.1s",
      fontWeight: "500",
      ...style == null ? void 0 : style.dropdown
    },
    dropdownHover: {
      backgroundColor: ((_g = theme == null ? void 0 : theme.colors) == null ? void 0 : _g.white) || "#ffffff",
      filter: "none",
      ...style == null ? void 0 : style.dropdownHover
    },
    dropdownOpen: {
      border: `1px solid #aeaeae`,
      // borderBottom: `1px solid ${theme?.colors?.charcoal}`,
      borderBottom: "1px solid transparent",
      backgroundColor: ((_h = theme == null ? void 0 : theme.colors) == null ? void 0 : _h.dropdownGray) || "#F5F5F5",
      borderRadius: "6px 6px 0 0",
      ...style == null ? void 0 : style.dropdownOpen
    },
    menu: {
      fontSize: "16px",
      top: "36px",
      maxHeight: "400px",
      ...style == null ? void 0 : style.menu
    },
    dropdownContent: {
      ...style == null ? void 0 : style.dropdownContent
    },
    dropdownContentInner: {
      maxWidth: "100%",
      padding: "10px 4px 10px 14px",
      lineHeight: "18px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      ...style == null ? void 0 : style.dropdownContentInner
    },
    inputHover: {
      backgroundColor: ((_i = theme == null ? void 0 : theme.colors) == null ? void 0 : _i.white) || "#ffffff",
      ...style == null ? void 0 : style.inputHover
    },
    placeholder: {
      color: ((_j = theme == null ? void 0 : theme.colors) == null ? void 0 : _j.nimbus) || COLORS.NIMBUS,
      ...style == null ? void 0 : style.placeholder
    },
    menuItem: {
      padding: "16px 14px"
    },
    menuItemSelected: {
      fontWeight: "500",
      ...(style == null ? void 0 : style.menuItemSelected) || {}
    }
  };
  return /* @__PURE__ */ React__default.createElement(
    Dropdown,
    {
      value,
      items,
      type: "text",
      onSelect,
      placeholder: "Empty",
      onFocus,
      onBlur,
      style: styles,
      disabled,
      valueOverride,
      ...other
    }
  );
};
DateRangeDropdown.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({})]),
  valueOverride: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({})]),
  onSelect: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  style: PropTypes.shape({}),
  items: PropTypes.arrayOf(PropTypes.shape({})),
  disabled: PropTypes.bool
};
export {
  DateRangeDropdown as default
};
//# sourceMappingURL=DateRangeDropdown.js.map
